import type { AgentChatMessage } from '@/frontend/pages/Dashboard/AgentChats/types'
import { reduceAgentEvents, type ContextUsage, type RunActivity } from '@/frontend/features/AgentChats/events/agentEvents'

export function latestContextUsage(
  activity: RunActivity | null,
  messages: AgentChatMessage[],
): ContextUsage | null {
  if (activity?.contextUsage) return activity.contextUsage

  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index]
    if (!message || message.role !== 'assistant') continue

    const usage = reduceAgentEvents(message.activity_events ?? [])?.contextUsage
    if (usage) return usage
  }

  return null
}
